import axiosInstance from '../utils/axiosInstance';

export const notificationService = {
  // Original system notification endpoints
  getUnreadCount: async (userId) => {
    const response = await axiosInstance.get(`/SmartProAPI/api/notifications/user/${userId}/unread/count`);
    return response.data;
  },

  getNotifications: async (userId) => {
    const response = await axiosInstance.get(`/SmartProAPI/api/notifications/user/${userId}`);
    return response.data;
  },

  markAsRead: async (notificationId) => {
    const response = await axiosInstance.put(`/SmartProAPI/api/notifications/${notificationId}/read`);
    return response.data;
  },

  // New Chat unread summary endpoints
  getChatUnreadCount: async () => {
    try {
      const response = await axiosInstance.get('/SmartProAPI/api/classes/unread-summary?limit=5');
      if (Array.isArray(response.data)) {
        return response.data.reduce((acc, curr) => acc + (curr.totalUnreadCount || 0), 0);
      }
      return 0;
    } catch (error) {
      console.error('Failed to fetch chat proxy unread count:', error);
      return 0;
    }
  },

  getChatNotifications: async () => {
    try {
      const response = await axiosInstance.get('/SmartProAPI/api/classes/unread-summary?limit=5');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch chat proxy unread summaries:', error);
      return [];
    }
  }
};
